/* ==========================================================================
   Lite Snacks — theme.js

   Every behaviour here is an enhancement. With JavaScript off:
   - add-to-cart forms post to /cart/add and land on the cart page
   - the mobile menu is a native <details> disclosure
   - the cart is the cart page; the drawer never appears
   - collection filters are links and sort has a visible submit button
   - product thumbnails are anchors into a scroll-snapping gallery
   ========================================================================== */

(function () {
  'use strict';

  var cfg = window.LiteSnacks || {};
  var routes = cfg.routes || {};
  var strings = cfg.strings || {};

  function $(selector, root) {
    return (root || document).querySelector(selector);
  }

  function $$(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function announce(message) {
    var region = document.getElementById('ls-live-region');
    if (!region || !message) return;
    // Clear first so repeat messages are still read out.
    region.textContent = '';
    window.setTimeout(function () {
      region.textContent = message;
    }, 60);
  }

  /* --- Money ------------------------------------------------------------ */

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = typeof precision === 'undefined' ? 2 : precision;
    thousands = typeof thousands === 'undefined' ? ',' : thousands;
    decimal = typeof decimal === 'undefined' ? '.' : decimal;

    if (isNaN(number) || number === null) return '0';

    var fixed = (number / 100.0).toFixed(precision);
    var parts = fixed.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var fraction = parts[1] ? decimal + parts[1] : '';
    return whole + fraction;
  }

  function formatMoney(cents) {
    var format = cfg.moneyFormat || '{{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholder);
    if (!match) return format;

    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return format.replace(placeholder, value);
  }


  function salePrice(id, price) {
    var sale = cfg.sale;
    var now = Date.now();
    return sale && now >= sale.start && now <= sale.end && sale.variants.indexOf(String(id)) !== -1
      ? Math.round(price * 0.85) : price;
  }

  function priceMarkup(price, compare) {
    return (compare > price ? '<s class="ls-price__was">' + formatMoney(compare) + '</s> ' : '') + formatMoney(price);
  }

  function refreshSalePrices() {
    $('[data-ls-sale-variant]').forEach(function (el) {
      if (el.closest('[data-ls-flav]') || el.closest('.ls-pdp')) return;
      var base = Number(el.getAttribute('data-ls-sale-base'));
      var price = salePrice(el.getAttribute('data-ls-sale-variant'), base);
      var compare = price < base ? base : Number(el.getAttribute('data-ls-sale-compare'));
      el.innerHTML = priceMarkup(price, compare);
    });
    $('[data-ls-flav]').forEach(function (card) {
      showFlavour(card, parseInt(card.getAttribute('data-ls-flav-index'), 10) || 0);
    });
    var form = $('.ls-pdp__form');
    if (form) refreshLineTotal(form.closest('.ls-pdp') || document);
  }

  /* --- Announcement bar -------------------------------------------------- */

  function initAnnouncement() {
    var bar = $('[data-ls-announcement]');
    if (!bar || bar.getAttribute('data-rotate') !== 'true') return;
    // The marquee style scrolls in CSS; only the static row rotates.
    if (!bar.classList.contains('ls-announcement--static')) return;

    var items = $$('.ls-announcement__item', bar);
    if (items.length < 2) return;

    var index = 0;
    items[0].classList.add('is-active');

    var interval = (parseInt(bar.getAttribute('data-interval'), 10) || 5) * 1000;

    window.setInterval(function () {
      items[index].classList.remove('is-active');
      index = (index + 1) % items.length;
      items[index].classList.add('is-active');
    }, interval);
  }

  /* --- Mobile menu ------------------------------------------------------- */

  function initMobileMenu() {
    var menu = $('[data-ls-menu]');
    if (!menu) return;

    function close() {
      menu.removeAttribute('open');
      var summary = $('summary', menu);
      if (summary) summary.focus();
    }

    menu.addEventListener('click', function (event) {
      if (event.target.closest('[data-ls-menu-close], [data-ls-menu-scrim]')) {
        event.preventDefault();
        close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu.hasAttribute('open')) close();
    });

    // Keep the panel pinned below whatever the header currently measures.
    function setOffset() {
      var header = $('[data-ls-header]');
      if (!header) return;
      var rect = header.getBoundingClientRect();
      menu.style.setProperty('--ls-menu-top', Math.max(0, rect.bottom) + 'px');
    }

    setOffset();
    window.addEventListener('resize', setOffset);
    menu.addEventListener('toggle', setOffset);
  }

  /* --- Cart drawer ------------------------------------------------------- */

  var Drawer = {
    el: null,
    lastTrigger: null,

    init: function () {
      this.el = $('[data-ls-drawer]');
      if (!this.el) return;

      var self = this;

      this.el.addEventListener('click', function (event) {
        if (event.target.closest('[data-ls-drawer-close]')) {
          event.preventDefault();
          self.close();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (!self.isOpen()) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          self.close();
        } else if (event.key === 'Tab') {
          self.trapFocus(event);
        }
      });
    },

    isOpen: function () {
      return this.el && !this.el.hasAttribute('hidden');
    },

    open: function (trigger) {
      if (!this.el) return;
      this.lastTrigger = trigger || document.activeElement;
      this.el.removeAttribute('hidden');
      document.body.classList.add('ls-no-scroll');

      var first = $('.ls-drawer__close', this.el);
      if (first) first.focus();
    },

    close: function () {
      if (!this.el || !this.isOpen()) return;
      this.el.setAttribute('hidden', '');
      document.body.classList.remove('ls-no-scroll');

      if (this.lastTrigger && document.contains(this.lastTrigger)) {
        this.lastTrigger.focus();
      }
      this.lastTrigger = null;
    },

    focusable: function () {
      var panel = $('.ls-drawer__panel', this.el);
      if (!panel) return [];
      return $$(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])',
        panel
      ).filter(function (el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0;
      });
    },

    trapFocus: function (event) {
      var items = this.focusable();
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    },

    setBusy: function (busy) {
      if (!this.el) return;
      this.el.classList.toggle('is-busy', !!busy);
    }
  };

  /* --- Cart data --------------------------------------------------------- */

  function sectionsToRequest() {
    var list = ['cart-drawer'];
    if ($('.ls-cart-page')) list.push('main-cart');
    return list;
  }

  function swapCartMarkup(sections) {
    if (!sections) return;

    if (sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = $('[data-ls-drawer-content]', doc);
      var current = $('.ls-drawer [data-ls-drawer-content]');
      if (fresh && current) current.replaceWith(fresh);
    }

    if (sections['main-cart']) {
      var pageDoc = new DOMParser().parseFromString(sections['main-cart'], 'text/html');
      var freshPage = $('[data-ls-drawer-content]', pageDoc);
      var currentPage = $('.ls-cart-page [data-ls-drawer-content]');
      if (freshPage && currentPage) currentPage.replaceWith(freshPage);
    }
  }

  function updateCartCount() {
    var source = $('[data-ls-drawer-content]');
    if (!source) return;

    var count = source.getAttribute('data-cart-count');
    if (count === null) return;

    $$('[data-ls-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function flashLine(key) {
    if (!key) return;
    var line = $('.ls-drawer [data-key="' + key + '"]') || $('[data-key="' + key + '"]');
    if (!line) return;
    line.classList.add('ls-line--flash');
    window.setTimeout(function () {
      line.classList.remove('ls-line--flash');
    }, 1600);
  }

  function handleCartError(error) {
    var message = (error && (error.description || error.message)) || strings.error;
    announce(message);
    // eslint-disable-next-line no-console
    if (window.console) console.warn('[Lite Snacks] cart error', error);
  }

  /* --- Add to cart ------------------------------------------------------- */

  function initAddForms() {
    if (!routes.cart_add_url) return;

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-ls-add-form], .ls-pdp__form');
      if (!form) return;

      event.preventDefault();

      var submit = form.querySelector('[type="submit"]');
      if (submit) submit.setAttribute('disabled', '');

      var data = new FormData(form);
      data.append('sections', sectionsToRequest().join(','));
      data.append('sections_url', window.location.pathname);

      fetch(routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data
      })
        .then(function (response) {
          return response.json().then(function (json) {
            if (!response.ok) throw json;
            return json;
          });
        })
        .then(function (json) {
          swapCartMarkup(json.sections);
          updateCartCount();

          var key = json.key || (json.items && json.items[0] && json.items[0].key);
          Drawer.open(submit);
          flashLine(key);
          announce(strings.added);
        })
        .catch(handleCartError)
        .then(function () {
          if (submit) submit.removeAttribute('disabled');
        });
    });
  }

  /* --- Cart line quantity ------------------------------------------------ */

  function changeLine(line, quantity) {
    if (!routes.cart_change_url) return;

    Drawer.setBusy(true);

    fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: sectionsToRequest().join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok) throw json;
          return json;
        });
      })
      .then(function (json) {
        swapCartMarkup(json.sections);
        updateCartCount();
        announce(quantity === 0 ? strings.removed : strings.updated);
      })
      .catch(handleCartError)
      .then(function () {
        Drawer.setBusy(false);
      });
  }

  function initCartLines() {
    document.addEventListener('click', function (event) {
      var control = event.target.closest('[data-ls-line-change]');
      if (!control) return;

      var lineEl = control.closest('[data-ls-line]');
      if (!lineEl) return;

      event.preventDefault();

      var quantity = parseInt(control.getAttribute('data-ls-line-change'), 10);
      var line = parseInt(lineEl.getAttribute('data-ls-line'), 10);
      if (isNaN(quantity) || isNaN(line)) return;

      // Optimistic: show the new number immediately, then reconcile.
      var input = $('[data-ls-line-input]', lineEl);
      if (input) input.value = Math.max(0, quantity);

      changeLine(line, Math.max(0, quantity));
    });

    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-ls-line-input]');
      if (!input) return;

      var lineEl = input.closest('[data-ls-line]');
      if (!lineEl) return;

      var quantity = Math.max(0, parseInt(input.value, 10) || 0);
      var line = parseInt(lineEl.getAttribute('data-ls-line'), 10);
      if (isNaN(line)) return;

      changeLine(line, quantity);
    });
  }

  /* --- Header cart trigger ----------------------------------------------- */

  function initCartTrigger() {
    var desktop = window.matchMedia('(min-width: 990px)');

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-ls-cart-toggle]');
      if (!trigger) return;

      // Mobile web uses the full cart page, as designed.
      if (!desktop.matches) return;
      if (cfg.cartDrawerEnabled === false) return;
      if (!$('[data-ls-drawer]')) return;

      event.preventDefault();
      Drawer.open(trigger);
    });
  }

  /* --- Product page ------------------------------------------------------ */

  function currentUnitPrice(scope) {
    var checked = $('[data-ls-variant-picker] input[type="radio"]:checked', scope);
    if (checked) return parseInt(checked.getAttribute('data-price'), 10);

    var select = $('[data-ls-variant-picker] select', scope);
    if (select) {
      var option = select.options[select.selectedIndex];
      if (option) return parseInt(option.getAttribute('data-price'), 10);
    }

    var total = $('[data-ls-line-total]', scope);
    if (total) return parseInt(total.getAttribute('data-unit-price'), 10);

    return NaN;
  }

  function refreshLineTotal(scope) {
    var totalEl = $('[data-ls-line-total]', scope);
    if (!totalEl) return;

    var unit = currentUnitPrice(scope);
    if (isNaN(unit)) return;

    var input = $('[data-ls-qty-input]', scope);
    var quantity = Math.max(1, parseInt(input && input.value, 10) || 1);

    var control = $('[name="id"]:checked', scope) || $('select[name="id"]', scope) || $('input[name="id"]', scope);
    var displayUnit = salePrice(control && control.value, unit);
    totalEl.textContent = formatMoney(displayUnit * quantity);
    var priceEl = $('.ls-pdp__price .ls-price', scope);
    if (priceEl) priceEl.innerHTML = priceMarkup(displayUnit, displayUnit < unit ? unit : 0);
  }

  function initProductForm() {
    var form = $('.ls-pdp__form');
    if (!form) return;

    var scope = form.closest('.ls-pdp') || document;

    // Quantity stepper
    form.addEventListener('click', function (event) {
      var up = event.target.closest('[data-ls-qty-up]');
      var down = event.target.closest('[data-ls-qty-down]');
      if (!up && !down) return;

      var input = $('[data-ls-qty-input]', form);
      if (!input) return;

      var value = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, up ? value + 1 : value - 1);
      refreshLineTotal(scope);
    });

    form.addEventListener('input', function (event) {
      if (event.target.closest('[data-ls-qty-input]')) refreshLineTotal(scope);
    });

    // Variant selection
    form.addEventListener('change', function (event) {
      var radio = event.target.closest('[data-ls-variant-picker] input[type="radio"]');
      if (radio) {
        $$('.ls-segmented__item', form).forEach(function (item) {
          item.classList.toggle('is-selected', item.contains(radio));
        });
      }

      if (radio || event.target.closest('[data-ls-variant-picker] select')) {
        refreshLineTotal(scope);
      }
    });

    refreshLineTotal(scope);
  }

  // The gallery is a horizontal scroll-snap strip with its scrollbar hidden.
  // On a merged product each figure is a different flavour, so it needs three
  // things: thumbnails, arrows, and — the one that costs a sale without it —
  // to follow the flavour the customer actually selected.
  function initGallery() {
    var gallery = $('[data-ls-gallery]');
    if (!gallery) return;

    var figures = $$('.ls-pdp__figure', gallery);
    if (figures.length < 2) return;

    var thumbs = $$('[data-ls-thumb]');
    var prev = $('[data-ls-gallery-prev]');
    var next = $('[data-ls-gallery-next]');

    // Nearest figure to the left edge, so a half-swiped scroller still reports
    // the slide the customer is actually looking at.
    function currentIndex() {
      var best = 0;
      var bestGap = Infinity;

      figures.forEach(function (figure, i) {
        var gap = Math.abs(figure.offsetLeft - gallery.offsetLeft - gallery.scrollLeft);
        if (gap < bestGap) {
          bestGap = gap;
          best = i;
        }
      });

      return best;
    }

    function syncControls() {
      var index = currentIndex();

      thumbs.forEach(function (thumb, i) {
        if (i === index) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });

      if (prev) prev.disabled = index <= 0;
      if (next) next.disabled = index >= figures.length - 1;
    }

    function goTo(index, behavior) {
      var i = Math.min(Math.max(index, 0), figures.length - 1);

      gallery.scrollTo({
        left: figures[i].offsetLeft - gallery.offsetLeft,
        behavior: behavior || 'smooth'
      });

      syncControls();
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function (event) {
        event.preventDefault();
        goTo(i);
      });
    });

    if (prev) {
      prev.addEventListener('click', function () {
        goTo(currentIndex() - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        goTo(currentIndex() + 1);
      });
    }

    // Swipe and trackpad scrolling bypass goTo, so keep the controls honest.
    var settle;
    gallery.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(syncControls, 80);
    });

    // Flavour -> photo. The section publishes "variantId:mediaId,..." and each
    // figure carries its media id, so choosing a flavour — or arriving on a
    // ?variant= deep link — lands on that flavour's own pack shot rather than
    // whichever one happens to be first.
    var media = $('[data-ls-variant-media]');
    var map = {};

    if (media) {
      (media.getAttribute('data-ls-variant-media') || '')
        .split(',')
        .forEach(function (pair) {
          var parts = pair.split(':');
          if (parts.length === 2 && parts[0] && parts[1]) map[parts[0]] = parts[1];
        });
    }

    function indexForVariant(id) {
      var mediaId = map[String(id)];
      if (!mediaId) return -1;

      for (var i = 0; i < figures.length; i++) {
        if (figures[i].getAttribute('data-ls-media-id') === mediaId) return i;
      }

      return -1;
    }

    function showSelectedVariant(behavior) {
      var picker = $('[data-ls-variant-picker]');
      if (!picker) return false;

      // Single-option products use radios, a variant matrix falls back to a
      // select; both are named `id` and carry the variant id.
      var control = $('input[name="id"]:checked', picker) || $('select[name="id"]', picker);
      var value = control ? control.value : null;
      if (!value) return false;

      var index = indexForVariant(value);
      if (index < 0) return false;

      goTo(index, behavior);
      return true;
    }

    var picker = $('[data-ls-variant-picker]');
    if (picker) {
      picker.addEventListener('change', function () {
        showSelectedVariant();
      });
    }

    // Jump, do not glide, on first paint: the customer never chose the photo
    // we would otherwise be scrolling away from.
    if (!showSelectedVariant('auto')) syncControls();
  }


  /* --- Collection sort --------------------------------------------------- */

  function initSort() {
    var form = $('[data-ls-sort-form]');
    if (!form) return;

    var select = $('select', form);
    if (!select) return;

    select.addEventListener('change', function () {
      form.submit();
    });
  }

  /* --- Boot -------------------------------------------------------------- */

  // The top strip is fixed, so the page reserves its height as padding and the
  // collection filter bar pins directly beneath it. That height is not a
  // constant — the announcement bar can be switched off, change font size, or
  // wrap on a narrow screen — so measure it and publish --ls-topbar-height for
  // the CSS to offset against.
  //
  // Measuring once on DOMContentLoaded is not enough: Fredoka is loaded async,
  // and the header is measured before it swaps in, giving a value ~17px short.
  // A stale value tucks the first row of products under the strip and hides the
  // top of the category tabs behind it. So re-measure at every point the height
  // can still change, and keep the largest sensible reading rather than trust
  // any single one.
  var topbarObserver = null;

  function initTopbarHeight() {
    var topbar = document.querySelector('.ls-topbar');
    if (!topbar) return;

    var apply = function () {
      var h = Math.round(topbar.getBoundingClientRect().height);
      if (!h) return;
      document.documentElement.style.setProperty('--ls-topbar-height', h + 'px');
    };

    apply();

    // Fonts swapping in is the one that actually bit us.
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(apply).catch(function () {});
    }

    window.addEventListener('load', apply);
    window.addEventListener('resize', apply);
    window.addEventListener('orientationchange', apply);

    if (typeof ResizeObserver === 'function') {
      // Re-init runs on section reload in the editor; drop the previous
      // observer so they do not stack up.
      if (topbarObserver) topbarObserver.disconnect();
      topbarObserver = new ResizeObserver(apply);
      topbarObserver.observe(topbar);
    }
  }

  /* --- Flavour cards ----------------------------------------------------- */

  // A card with several flavours carries one JSON row per flavour. Stepping
  // through them swaps the photo, name, price, badge, links and the hidden
  // variant id, so the Add button posts whichever flavour is on show.
  //
  // State lives in a data attribute on the card and every handler is
  // delegated from the document, so a grid swapped in by the theme editor or
  // a section render needs no re-binding.

  function flavRows(card) {
    if (card.lsFlavRows) return card.lsFlavRows;
    var raw = card.getAttribute('data-ls-flav-rows');
    if (!raw) return null;
    try {
      card.lsFlavRows = JSON.parse(raw);
    } catch (error) {
      return null;
    }
    return card.lsFlavRows;
  }

  // Only the starting photo is in the markup. Pull the rest down once the
  // customer shows interest in the card, so the first arrow press does not
  // flash an empty box.
  function preloadFlavours(card) {
    if (card.lsFlavPreloaded) return;
    card.lsFlavPreloaded = true;

    var rows = flavRows(card);
    if (!rows) return;

    var sizes = '';
    var img = $('[data-ls-flav-img]', card);
    if (img) sizes = img.getAttribute('sizes') || '';

    rows.forEach(function (row) {
      if (!row.u) return;
      var pre = new Image();
      if (sizes) pre.sizes = sizes;
      if (row.s) pre.srcset = row.s;
      pre.src = row.u;
    });
  }

  function showFlavour(card, index) {
    var rows = flavRows(card);
    if (!rows || !rows.length) return;

    // Wrap in both directions, so the arrows never dead-end.
    var i = ((index % rows.length) + rows.length) % rows.length;
    var row = rows[i];
    var displayedPrice = salePrice(row.i, row.p);
    var displayedCompare = displayedPrice < row.p ? row.p : row.c;
    var onSale = displayedCompare > displayedPrice;

    card.setAttribute('data-ls-flav-index', i);

    var img = $('[data-ls-flav-img]', card);
    if (img && row.u) {
      img.srcset = row.s || '';
      img.src = row.u;
      img.alt = row.l || '';
    }

    var name = $('[data-ls-flav-name]', card);
    if (name) name.textContent = row.t;

    var price = $('.ls-price', card);
    if (price) {
      price.innerHTML = priceMarkup(displayedPrice, displayedCompare);
    }

    // A group can hold one flavour on sale and another at full price, so the
    // badge is recomputed per flavour rather than left at the product's.
    var badge = $('[data-ls-flav-badge]', card);
    if (badge) {
      if (onSale) {
        var percent = Math.round(((displayedCompare - displayedPrice) * 100) / displayedCompare);
        var label = (card.getAttribute('data-ls-save-label') || '').replace('__PCT__', percent);
        badge.innerHTML = '<span class="ls-badge ls-badge--save">' + label + '</span>';
      } else {
        badge.innerHTML = card.getAttribute('data-ls-flav-badge-fallback') || '';
      }
    }

    // Land on the chosen flavour when the customer opens the product page.
    var url = card.getAttribute('data-ls-flav-url');
    if (url) {
      $$('[data-ls-flav-link]', card).forEach(function (link) {
        link.href = url + '?variant=' + row.i;
      });
    }

    var id = $('[data-ls-flav-id]', card);
    if (id) id.value = row.i;

    var add = $('[data-ls-flav-add]', card);
    if (add) {
      add.disabled = !row.a;
      var addLabel = $('[data-ls-flav-add-label]', add);
      if (addLabel) {
        addLabel.textContent = row.a
          ? card.getAttribute('data-ls-add-label') || ''
          : card.getAttribute('data-ls-sold-label') || '';
      }
    }

    $$('[data-ls-flav-dot]', card).forEach(function (dot) {
      var active = parseInt(dot.getAttribute('data-ls-flav-dot'), 10) === i;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function initFlavourCards() {
    document.addEventListener('click', function (event) {
      var step = event.target.closest('[data-ls-flav-step]');
      var dot = event.target.closest('[data-ls-flav-dot]');
      if (!step && !dot) return;

      var card = (step || dot).closest('[data-ls-flav]');
      if (!card) return;

      event.preventDefault();
      preloadFlavours(card);

      var current = parseInt(card.getAttribute('data-ls-flav-index'), 10) || 0;
      showFlavour(
        card,
        step ? current + (parseInt(step.getAttribute('data-ls-flav-step'), 10) || 0)
             : parseInt(dot.getAttribute('data-ls-flav-dot'), 10) || 0
      );
    });

    // Pointer over the card is a good enough signal to start fetching the
    // other photos; on touch the first press does it instead.
    document.addEventListener(
      'pointerenter',
      function (event) {
        var card = event.target.closest && event.target.closest('[data-ls-flav]');
        if (card) preloadFlavours(card);
      },
      true
    );
  }

  function init() {
    initTopbarHeight();
    initAnnouncement();
    initMobileMenu();
    Drawer.init();
    initAddForms();
    initFlavourCards();
    initCartLines();
    initCartTrigger();
    initProductForm();
    initGallery();
    initSort();
    refreshSalePrices();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.setInterval(refreshSalePrices, 30000);

  // Re-bind the pieces that hold their own state when the theme editor
  // swaps a section out from under us.
  document.addEventListener('shopify:section:load', function () {
    initTopbarHeight();
    initAnnouncement();
    initMobileMenu();
    Drawer.init();
    initProductForm();
    initGallery();
    initSort();
  });
})();
